import { createStore } from "redux";
import rootReducer from "./reducers"; // You need to create this rootReducer

import { composeWithDevTools } from "redux-devtools-extension";

const store = createStore(rootReducer, composeWithDevTools());

export default store;
